import { useAsync } from '@tumelo/react'
import { use } from 'react'
import { ClientContext } from '../../client'

export const useGetUser = () => {
  const getClient = use(ClientContext)

  return useAsync(async () => {
    const client = await getClient()
    return await client.GetUser({})
  })
}
